import { IonAlert, IonSpinner } from '@ionic/react'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserContext } from '../../../contexts/UserContext'
import { trpc } from '../../../modules/trpc'
import PendingContract, { PendingContract as PendingContractType } from './PendingContract'

const PendingContracts: React.FC = () => {
	const { isAnonymousUser } = useContext(UserContext)

	const { t } = useTranslation('pages_contractInformation')
	const utils = trpc.useContext()
	const [contractToCancel, setContractToCancel] = useState<PendingContractType | null>(null)

	const { data: pendingContracts, isFetching: loading } = trpc.contact.getPendingContracts.useQuery(
		undefined,
		{
			enabled: !isAnonymousUser,
		}
	)

	const cancelMutation = trpc.contact.requestContractCancellation.useMutation({
		onSuccess: () => {
			setContractToCancel(null)
			utils.contact.getPendingContracts.invalidate()
		},
	})

	return (
		<div className='container' style={{ marginBottom: '12px' }}>
			<p className='header font-semibold text-md text-text-dark dark:text-white'>
				{t('pendingOrders')}
			</p>
			<p className='text text-xs text-text-grey-200 dark:text-text-grey-100 mt-1'>
				{t('cancellationRight')}
			</p>

			{loading && (
				<div className='flex justify-center py-4'>
					<IonSpinner name='crescent' />
				</div>
			)}

			{!loading &&
				pendingContracts?.map(contract => (
					<PendingContract
						key={contract.id}
						contract={contract}
						disabled={cancelMutation.isLoading}
						onSelect={setContractToCancel}
					/>
				))}

			<IonAlert
				isOpen={contractToCancel !== null}
				onDidDismiss={() => setContractToCancel(null)}
				header={t('cancelOrderConfirmHeader')}
				message={t('cancelOrderConfirmMessage', {
					productName: contractToCancel?.productName ?? '',
				})}
				buttons={[
					{
						text: t('cancelOrderConfirmCancel'),
						role: 'cancel',
					},
					{
						text: t('cancelOrderConfirmConfirm'),
						role: 'destructive',
						handler: () => {
							if (contractToCancel !== null) cancelMutation.mutate({ id: contractToCancel.id })
						},
					},
				]}
			/>
		</div>
	)
}

export default PendingContracts
